export default __webpack_public_path__ + "static/media/scoping.90b4a900.svg";